import styled from 'styled-components'

export const ShareForum = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 16px;
  background-color: var(--gray100);
  border-radius: 8px;

  div {
    flex: 1;

    span {
      margin: 0;
    }
  }
`
